<mat-sidenav-container>
  <mat-sidenav class="main row create_campaign" #sidenav mode="over" position="end" [opened]="true" disableClose>
    <div class="sliding-sheet-header">
      <h4>Preview Cma</h4>
      <button type="button" (click)="close()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="slidesheetcontent preview">
      <div class="slider-container">
        <div class="slide-content">
          <app-view-cma-property-details
            *ngIf="components[currentIndex] === 'property-details'"
          ></app-view-cma-property-details>
          <app-view-cma-comparables *ngIf="components[currentIndex] === 'compare'"></app-view-cma-comparables>
          <app-view-cma-valuation *ngIf="components[currentIndex] === 'valuation'"></app-view-cma-valuation>
          <app-view-cma-trends *ngIf="components[currentIndex] === 'cma-trends'"></app-view-cma-trends>
          <app-view-cma-more *ngIf="components[currentIndex] === 'more'"></app-view-cma-more>
        </div>
        <button class="arrow left" (click)="prevSlide()">&#9664;</button>
        <button class="arrow right" (click)="nextSlide()">&#9654;</button>
      </div>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
